import { render, staticRenderFns } from "./StrCategoryAutocomplete.vue?vue&type=template&id=c04f3622&scoped=true&"
import script from "./StrCategoryAutocomplete.vue?vue&type=script&lang=js&"
export * from "./StrCategoryAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04f3622",
  null
  
)

export default component.exports